var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.editMode || (_vm.editMode && _vm.editFull),
              expression: "!editMode || (editMode && editFull)",
            },
          ],
          staticClass: "row pb-2",
        },
        [
          _c("div", { staticClass: "col-7 col-no-padding" }, [
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.label"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.label,
                      expression: "label",
                    },
                  ],
                  ref: "label",
                  staticClass: "form-input col-12",
                  class: _vm.isLabelMissing && "invalid",
                  attrs: { type: "text" },
                  domProps: { value: _vm.label },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.label = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.isLabelMissing
                  ? _c("p", { staticClass: "text-danger-600 m-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("validation.required_field")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.address"))),
                ]),
                _vm._v(" "),
                _vm.parentIsSite
                  ? _c("div", { staticClass: "col-12 simple-checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.siteAddressChecked,
                            expression: "siteAddressChecked",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "sameAddress",
                          id: "sameAddress",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.siteAddressChecked)
                            ? _vm._i(_vm.siteAddressChecked, null) > -1
                            : _vm.siteAddressChecked,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = _vm.siteAddressChecked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.siteAddressChecked = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.siteAddressChecked = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.siteAddressChecked = $$c
                              }
                            },
                            _vm.siteAddress,
                          ],
                        },
                      }),
                      _c("label", { attrs: { for: "sameAddress" } }, [
                        _vm._v(_vm._s(_vm.$t("plans.form.sameAddress"))),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("AddressField", {
                      attrs: {
                        address: _vm.address,
                        fullAddress: _vm.address,
                        disabled: _vm.siteAddressChecked,
                      },
                      on: {
                        location: _vm.handleLocation,
                        centerMap: _vm.handleMapCenter,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-5 col-no-padding" },
            [
              _c("MiniMap", {
                ref: "minimap",
                attrs: {
                  id: "minimap-building",
                  center: _vm.center,
                  zoom: _vm.zoom,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editMode && !_vm.editFull,
              expression: "editMode && !editFull",
            },
          ],
          staticClass: "row pb-2",
        },
        [
          _c("div", { staticClass: "col-12 col-no-padding" }, [
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm.$t("plans.form.label"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.label,
                      expression: "label",
                    },
                  ],
                  staticClass: "form-input col-12",
                  class: _vm.isLabelMissing && "invalid",
                  attrs: { type: "text" },
                  domProps: { value: _vm.label },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.label = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.isLabelMissing
                  ? _c("p", { staticClass: "text-danger-600 m-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("validation.required_field")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "not-fixed p-4 justify-content-end" },
        [
          _c(
            "Btn",
            {
              staticClass: "primary",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSave($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("global.save")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.cancel($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("global.cancel")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }